/**
 * Generación de payload para nuevo tab
 * @param {String} name Nombre para el tab
 * @param {String} routeName Nombre de la ruta a abrir
 * @param {Object} params Parámetros opcionales a recibir
 * @return {Object} Payload with route
 */
function generateTabPayload(name, routeName, params = {}) {
    const item = {
        active: true,
        name: `${name}`,
        route: {
            name: `${routeName}`,
            params,
            force: true
        }
    };
    return item;
}

export { generateTabPayload };
